import { useTranslation } from 'react-i18next';
import './contract-info-card.component.scss';
import { Contract, ContractsTable } from './contracts-table.component';
import { useState } from 'react';

const blobURL = import.meta.env.VITE_API_IMAGE_URL;

const workAgrementSwedish = `${blobURL}/Allmänt avtal för Egenanställning.pdf`;
const workAgrementEnglish = `${blobURL}/General Contract for Self-Employment.pdf`;
const AgreementSwedish = `${blobURL}/AgrementSwedish.pdf`;
const EnglishAgreement = `${blobURL}/EnglishAgrement.pdf`;

export const ContractInfoCard = () => {
  const { t } = useTranslation();
  const language =
    new URLSearchParams(window.location.search).get('lang') || 'en';

  const handleEmploymentClick = () => {
    window.open(language === 'sv-se' ? AgreementSwedish : EnglishAgreement);
  };

  const [contracts] = useState<Contract[]>([
    {
      id: '1',
      document: 'GENERAL_DOCUMENT',
      duration: '12/05/2023 - 11/09/2024',
      fileUrl:
        language === 'sv-se'
          ? workAgrementSwedish
          : workAgrementEnglish,
    },
  ]);

  return (
    <div className="contract-info-card">
      <div className="contract-info-card__header">
        <h2 className="contract-info-card__title">
          {t('CONTRACT_WITH_INVOZIO')}
        </h2>
      </div>

      <div className="contract-info-card__options">
        {/* BOX 1 – Employment Contract */}
        <div className="contract-info-card__option-card">
          <h3 className="contract-info-card__option-title">
            {t('EMPLOYMENT_CONTRACT')}
          </h3>

          <p className="contract-info-card__option-description">
            {t('CONTRACT_DESCRIPTION')}
          </p>

          <button
            className="contract-info-card__primary-btn"
            onClick={handleEmploymentClick}
          >
            {t('EMPLOYMENT_CONTRACT')}
          </button>
        </div>

        {/* BOX 2 – Invozio Agreement */}
        <div className="contract-info-card__option-card">
          <h3 className="contract-info-card__option-title">
            {t('INVOZIO_AGREEMENT')}
          </h3>

          <p className="contract-info-card__option-description">
            {t('agrself')}
          </p>

          <div className="contract-info-card__table-wrapper">
            <ContractsTable contracts={contracts} />
          </div>
        </div>
      </div>
    </div>
  );
};
